import script from "./HomeGuide.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeGuide.vue?vue&type=script&setup=true&lang=js"

import "./HomeGuide.vue?vue&type=style&index=0&id=da1e5956&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-da1e5956"]])

export default __exports__